export const ACCEPTED_BRANDING_MAX_FILE_SIZE = 1000000 // reduced to 1MB because that is the default max for the server actions for nextjs
export const ACCEPTED_BRANDING_FILE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"]
export const ACCEPTED_MAPPING_MAX_FILE_SIZE = 1000000
export const ACCEPTED_MAPPING_FILE_TYPES: string[] = [
  "text/plain",
  "text/csv",
  "application/csv",
  "application/vnd.ms-excel",
]
